// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"1c6b64c5","336":"f973d2c4"}[chunkId] + ".chunk.js";
};